import { createContext, useContext, type ReactNode } from 'react';
import type { StaffCitation } from '../../types/staff';

interface StaffCitationsValue {
  citations: Record<string, StaffCitation>;
  /** Unix seconds the payload was generated; relative times are frozen at this moment. */
  generatedAt: number;
}

const StaffCitationsContext = createContext<StaffCitationsValue>({ citations: {}, generatedAt: 0 });

interface StaffCitationsProviderProps extends StaffCitationsValue {
  children: ReactNode;
}

/** Makes a profile's citation map available to every evidence chip beneath it. */
export const StaffCitationsProvider = ({ citations, generatedAt, children }: StaffCitationsProviderProps) => (
  <StaffCitationsContext.Provider value={{ citations, generatedAt }}>{children}</StaffCitationsContext.Provider>
);

export const useStaffCitations = () => useContext(StaffCitationsContext);
